const COOKIE_OPTIONS_SUFFIX =
  'expires=Wed, 16 Jan 2030 12:00:00 UTC; path=/; domain=hire3x.com;'

const COOKIE_CLEAR_SUFFIX =
  'expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=hire3x.com;'

export { COOKIE_OPTIONS_SUFFIX, COOKIE_CLEAR_SUFFIX };
